import React, {useEffect, useMemo, useState} from 'react';
import Translate from 'components/Translate';
import ImportTemplates from "./ImportTemplates";
import {
    addTemplate as addTemplateRequest,
    deleteTemplate,
    editTemplate,
    getTemplates,
    importTemplatesF
} from "../../../../../../../../services/company/api";
import TemplatesViewModal from "./partials/TemplatesViewModal";
import FolderOpenIcon from "../../../../../../../../assets/icons/FolderOpenIcon";
import PlusIcon from "../../../../../../../../assets/icons/PlusIcon";
import './styles.css'
import SearchInput from "../../../../../../../../components-new/form/SearchInput";
import SilverButton from "../../../../../../../../components-new/buttons/SilverButton";
import config from "../../../../../../../../config";
import NewFolderModal from "./partials/NewFolderModal";

const Templates = ({clients, user, client, addNotification}) => {
    const [templates, setTemplates] = useState([]);
    const [folderSearch, setFolderSearch] = useState('');
    const [templateSearch, setTemplateSearch] = useState('');
    const [selectedFolder, setSelectedFolder] = useState(null);
    const [modalOpen, setModalOpen] = useState(false);
    const [newFolderModalOpen, setNewFolderModalOpen] = useState(false);

    const filteredFolders = useMemo(() => {
        const groupedTemplates = templates.reduce((acc, template) => {
            if (!acc[template.folderName]) acc[template.folderName] = [];
            acc[template.folderName].push(template);
            return acc;
        }, {});

        const searchLower = folderSearch.toLowerCase();

        return Object.entries(groupedTemplates).filter(([folderName, templatesInFolder]) =>
            folderName.toLowerCase().includes(searchLower) ||
            templatesInFolder.some(template => template.text.toLowerCase().includes(searchLower))
        );
    }, [templates, folderSearch]);

    useEffect(() => {
        getTemplates(client.id).then((data) => {
            setTemplates(data);
        });
    }, [client.id]);

    const handleImportTemplate = (originalCompanyId, folderName) => {
        importTemplatesF(client.id, originalCompanyId, folderName).then(() => {
            getTemplates(client.id).then((data) => {
                setTemplates(data);
                addNotification('imported', config.notificationLevels.info);
            });
        });
    };

    const handleDeleteTemplate = (templateId) => {
        deleteTemplate(client.id, templateId).then(() => {
            setTemplates(templates.filter(template => template.id !== templateId));
        });
        addNotification('deleted', config.notificationLevels.info)
    };

    const handleSaveTemplate = (templateId, val, folderName) => {
        if (!val.trim()) {
            if (templateId) {
                handleDeleteTemplate(templateId)
            } else {
                removeNewTemplate(folderName)
            }
            return;
        }

        if (templateId) {
            editTemplate(client.id, val, folderName, templateId).then(() => {
                setTemplates(templates.map(template =>
                    template.id === templateId
                        ? {...template, text: val, folderName: folderName}
                        : template
                ));
                addNotification('updated', config.notificationLevels.info)
            });
        } else {
            addTemplateRequest(client.id, val, folderName).then((data) => {
                setTemplates([...templates.filter(t => !(t.id === null && t.folderName === folderName)), data]);
            });
            addNotification('added', config.notificationLevels.success)
        }
    };

    const addTemplate = (folderName) => {
        setTemplateSearch('');
        if (!templates.some(template => template.folderName === folderName && template.id === null)) {
            setTemplates([...templates, {id: null, text: '', folderName, isNew: true}]);
        }
    };

    const handleTemplateFolderClick = (folderName) => {
        setSelectedFolder(folderName);
        setModalOpen(true)
    };

    const removeNewTemplate = (folderName) => {
        setTemplates(templates.filter(t => t.id !== null || t.folderName !== folderName));
    }

    const handleNewFolderSave = (folderName) => {
        if (!templates.some(t => t.folderName === folderName)) {
            setTemplates([...templates, {id: null, text: '', folderName, isNew: true}]);
        }
        setNewFolderModalOpen(false);
    }

    return (
        <div className="stg-page resources-templates-page">
            <div className="stg-card">
                <div className="stg-card__head">
                    <div>
                        {/*<h2 className="stg-card__title"><Translate text={'templateFolders'}/></h2>*/}
                        <p className="stg-card__note"><Translate text="templatesInfo"/></p>
                    </div>

                    <SilverButton
                        size="md"
                        width={'auto'}
                        onClick={() => setNewFolderModalOpen(true)}
                    >
                        <PlusIcon width={16} height={16} stroke="currentColor"/>
                        <Translate text={'addFolder'}/>
                    </SilverButton>
                </div>

                <SearchInput
                    value={folderSearch}
                    onChange={e => setFolderSearch(e.target.value)}
                    style={{width: '100%', maxWidth: '360px'}}
                />

                <div className="templates-folders">
                    {filteredFolders.map(([folderName]) => (
                        <div
                            key={folderName}
                            onClick={() => handleTemplateFolderClick(folderName)}
                            className="templates-folder-card"
                        >
                            <div className="template-card-content">
                                <FolderOpenIcon width={20} height={20} stroke="currentColor"/>
                                <strong className="template-folder-name">{folderName}</strong>
                            </div>

                            <div
                                onClick={(e) => {
                                    e.stopPropagation();
                                    setSelectedFolder(folderName);
                                    setModalOpen(true);
                                    addTemplate(folderName);
                                }}
                                className="template-card-add"
                            >
                                <PlusIcon width={16} height={16} stroke="currentColor"/>
                            </div>
                        </div>
                    ))}
                </div>

                {filteredFolders.length === 0 &&
                    <div className="stg-empty"><Translate text="noFolders"/></div>
                }
            </div>

            <div className="stg-card">
                <div className="stg-card__head">
                    <div>
                        <h2 className="stg-card__title"><Translate text={'importTemplates'}/></h2>
                        <p className="stg-card__note"><Translate text="importTemplatesInfo"/></p>
                    </div>
                </div>

                <ImportTemplates
                    user={user}
                    clients={clients.filter(c => client.id !== c.id)}
                    onImport={handleImportTemplate}
                />
            </div>

            {modalOpen &&
                <TemplatesViewModal
                    isOpen={modalOpen}
                    folderName={selectedFolder}
                    templates={templates}
                    handleDeleteTemplate={handleDeleteTemplate}
                    removeNewTemplate={removeNewTemplate}
                    handleSaveTemplate={handleSaveTemplate}
                    addTemplate={addTemplate}
                    search={templateSearch}
                    setSearch={setTemplateSearch}
                    onClose={() => {
                        setModalOpen(false);
                        removeNewTemplate(selectedFolder);
                    }}
                />
            }

            {newFolderModalOpen &&
                <NewFolderModal
                    isOpen={newFolderModalOpen}
                    onSave={handleNewFolderSave}
                    onClose={() => setNewFolderModalOpen(false)}
                    user={user}
                />
            }

        </div>
    )
}

export default Templates;



// WEBPACK FOOTER //
// ./src/scenes/dashboard/components/management/clients/new/resources/templates/index.jsx